module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"create_review":"상품 리뷰 작성하기"}}')
  delete Component.options._Ctor
}
